// extracted by mini-css-extract-plugin
export var border = "_bo-b";
export var circle = "_bo-4";
export var circleInner = "_bo-5";
export var disabled = "_bo-1";
export var focused = "_bo-a";
export var md = "_bo-8";
export var radioButton = "_bo-0";
export var radioInput = "_bo-2";
export var selected = "_bo-9";
export var sm = "_bo-7";
export var text = "_bo-3";
export var xs = "_bo-6";